module.exports = __webpack_public_path__ + "img/WechatIMG18516.31923f32.jpg";